export default {
  buy_desc_1: 'Admite más de 1000 blockchains',
  buy_desc_2: 'Incluye BTC, ETH, TRON, BSC y cadenas públicas EVM',
  buy_desc_3: 'Un solo dispositivo para gestionar todos los criptoactivos',

  features: 'Características',
  features_title_1: 'Chip de seguridad MCU+SE',
  features_desc_1: 'Chips de grado militar que garantizan la seguridad',
  features_title_2: 'Pantalla LCD de 2,0 pulgadas',
  features_desc_2: 'Más detalles de la transacción; firmas lo que ves',
  features_title_3: 'Conexión Bluetooth',
  features_desc_3: 'Comunicación desensibilizada',
  features_title_4: 'Protecciones en múltiples capas',
  features_desc_4: 'Modo sin conexión, código PIN, conexión identificada',
  color: 'Color',
  free_shipping: 'Envío gratuito',

  break_down_desc_1: 'Botón IZQUIERDA',
  break_down_desc_2: 'Mover a la izquierda en la pantalla o volver a la página anterior',
  break_down_desc_3: 'Botón OK',
  break_down_desc_4: 'Confirmar acciones o entrar al menú; mantener pulsado para encender/apagar',
  break_down_desc_5: 'Botón ARRIBA',
  break_down_desc_6: 'Mover hacia arriba en la pantalla',
  break_down_desc_7: 'Botón DERECHA',
  break_down_desc_8: 'Mover a la derecha en la pantalla o confirmar acciones',
  break_down_desc_9: 'Botón ABAJO',
  break_down_desc_10: 'Mover hacia abajo en la pantalla',

  display_title: 'Pantalla',
  display_desc: 'Pantalla LCD de 2 pulgadas',
  battery_title: 'Batería',
  battery_desc: '100mAh',
  materials_title: 'Materiales',
  materials_desc: 'Aleación de aluminio',
  dual_chip_title: 'Doble chip',
  dual_chip_desc: 'Chips de seguridad MCU + SE',

  easy_and_safe_title: 'Fácil y seguro',
  easy_and_safe_desc: 'Conexión y uso sencillos, protección segura de los criptoactivos',
  easy_and_safe_list_1: 'Doble chip',
  easy_and_safe_list_2: 'Chip de seguridad MCU + SE',
  easy_and_safe_list_3: 'Conexión sencilla',
  easy_and_safe_list_4: 'Bluetooth y Type-C',
  easy_and_safe_list_5: 'Pantalla de 2 pulgadas',
  easy_and_safe_list_6: 'Firmas lo que ves',

  product_specifications: 'Especificaciones del producto',
  detail_center: 'USB Type-C',
  detail_left_1: 'Carcasa de aleación de aluminio Protege la billetera contra daños',
  detail_left_2: 'Botón IZQUIERDA',
  detail_left_3: 'Botón ABAJO',
  detail_right_1: 'Pantalla de 2 pulgadas Para mostrar la transacción relacionada',
  detail_right_2: 'Botón ARRIBA',
  detail_right_3: 'Botón DERECHA',
  detail_right_4: 'Botón OK',

  keypal_card_1: 'Tamaño',
  keypal_card_label_1: '91mm*55mm*6.7mm',
  keypal_card_2: 'Energía y batería',
  keypal_card_label_2: 'Batería de iones de litio de 100mAh',
  keypal_card_3: 'Conexión',
  keypal_card_label_3: 'Bluetooth & Type-C',
  keypal_card_4: 'Materiales',
  keypal_card_label_4: 'Aleación de aluminio, plástico',
  keypal_card_5: 'Peso',
  keypal_card_label_5: '53g',
  keypal_card_6: 'Pantalla',
  keypal_card_label_6: 'Pantalla LCD de 2 pulgadas',
  keypal_card_7: 'Chip',
  keypal_card_label_7: 'MCU+SE',
  keypal_card_8: 'Certificaciones',
  keypal_card_label_8: 'DOE CEC BEC CE FCC RoHS',

  package: 'Contenido del paquete',
  package_line_1: '1 billetera de hardware',
  package_line_2: '1 cable USB Type-C',
  package_line_3: '2 hojas de recuperación',
  package_line_4: '1 pegatina',

  keypal_plus: {
    larger_battery: 'Capacidad de batería un 200% mayor',

    keypal_card_1: 'Tamaño',
    keypal_card_label_1: '91mm*55mm*9.0mm',
    keypal_card_2: 'Energía y batería',
    keypal_card_label_2: 'Batería de iones de litio de 300mAh',
    keypal_card_3: 'Conexión',
    keypal_card_label_3: 'Bluetooth & Type-C',
    keypal_card_4: 'Materiales',
    keypal_card_label_4: 'Aleación de aluminio, plástico',
    keypal_card_5: 'Peso',
    keypal_card_label_5: '63g',
    keypal_card_6: 'Pantalla',
    keypal_card_label_6: 'Pantalla LCD de 2 pulgadas',
    keypal_card_7: 'Chip',
    keypal_card_label_7: 'MCU+SE',
    keypal_card_8: 'Certificaciones',
    keypal_card_label_8: 'DOE CEC BEC CE FCC RoHS',

    color: 'Color',
    color_desc: 'Negro, Plata, Dorado',
    battery: 'Batería',
    battery_desc: '300 mAh',
    left: 'Izquierda',
    down: 'Abajo',
    right: 'Derecha',
    up: 'Arriba',
    ok: 'OK',
    center: 'USB Type-C',
    left_1: 'Botón IZQUIERDA',
    left_2: 'Mover a la izquierda en la pantalla o volver atrás',
    left_3: 'Botón ABAJO',
    left_4: 'Mover hacia abajo en la pantalla',
    right_1: 'Botón ARRIBA',
    right_2: 'Mover hacia arriba en la pantalla',
    right_3: 'Botón DERECHA',
    right_4: 'Mover a la derecha en la pantalla o confirmar',
    right_5: 'Botón OK',
    right_6: 'Confirmar acciones o entrar al menú; mantener pulsado para encender/apagar',
    mobile_center: 'Type-C',
    mobile_center_2: 'Para cargar y actualizar el firmware',
  },
};
